import { Form } from '@mairistem/composants';
import { MULTI } from '@mairistem/comptabilite';
import { Icon, Panel } from '@mairistem/finances-utils';
import { isEmpty } from 'lodash';
import React from 'react';
import { toast } from 'react-toastify';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const InformationsChorusProComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleClick = () => {
		if (!isEmpty(data?.factureChorus) && data?.factureChorus !== MULTI) {
			toast.info('Le status est VIDE', { toastId: 'toastChorusStatus' });
		}
	};

	const handleChange = (_e, { name, value }) =>
		onChange?.({ [name]: value }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Group className="panelRow">
					<Form.Input
						name="factureChorus"
						label="Numéro de facture"
						onChange={handleChange}
						width={14}
						maxLength={20}
						value={data?.factureChorus ?? ''}
						data-testid="informationsChorusProPanelInput"
					/>
					<Form.Input
						control={Icon}
						name="info circle"
						size="large"
						circular
						width={2}
						className="panelButton"
						onClick={handleClick}
						data-testid="informationsChorusProPanelIcon"
					/>
				</Form.Group>
			</Form>
		</Panel>
	);
};

export default InformationsChorusProComponent;
